import { getValue } from 'firebase/remote-config';
import remoteConfig from './remoteConfig';
import { isTruthy } from './utils';
const env = import.meta.env ?? process.env;

export function getConfig() {
  if (isTruthy(env.VITE_IS_LOCAL)) {
    return {
      LOTVISION_URL: env.VITE_LOTVISION_URL || 'http://localhost:3004/api/v1',
      SITE_ID: env.VITE_SITE_ID || '',
      IS_PLAYWRIGHT: isTruthy(env.VITE_IS_PLAYWRIGHT) || false,
      PROD_ENABLED_CLIENTS: (
        env.VITE_PROD_ENABLED_CLIENTS || 'ALL_CLIENTS'
      ).split(','), //temporary safety net, working on backend solution
    };
  } else {
    return {
      LOTVISION_URL:
        `${getValue(remoteConfig, 'LOTVISION_URL').asString()}/api/v1` ||
        'http://localhost:3004/api/v1',
      SITE_ID: getValue(remoteConfig, 'SITE_ID').asString() || '',
      IS_PLAYWRIGHT:
        isTruthy(getValue(remoteConfig, 'IS_PLAYWRIGHT').asBoolean()) || false,
      PROD_ENABLED_CLIENTS: (
        getValue(remoteConfig, 'PROD_ENABLED_CLIENTS').asString() ||
        'ALL_CLIENTS'
      ).split(','), //temporary safety net, working on backend solution
    };
  }
}

export const ORG_MANHEIM_CODE = 'mn';
